import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const FamilyForm = ({ data, onSave }) => {
  const [formData, setFormData] = useState({
    parent1_first_name: data?.parent1_first_name || '',
    parent1_last_name: data?.parent1_last_name || '',
    parent1_email: data?.parent1_email || '',
    parent1_occupation: data?.parent1_occupation || '',
    parent1_education: data?.parent1_education || '',
    parent2_first_name: data?.parent2_first_name || '',
    parent2_last_name: data?.parent2_last_name || '',
    parent2_email: data?.parent2_email || '',
    parent2_occupation: data?.parent2_occupation || '',
    parent2_education: data?.parent2_education || '',
    siblings: data?.siblings || 0,
    household_income: data?.household_income || ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-4">Parent/Guardian 1</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="parent1FirstName">First Name *</Label>
            <Input
              id="parent1_first_name"
              name="parent1_first_name"
              value={formData.parent1_first_name}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <Label htmlFor="parent1_last_name">Last Name *</Label>
            <Input
              id="parent1_last_name"
              name="parent1_last_name"
              value={formData.parent1_last_name}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <Label htmlFor="parent1_email">Email</Label>
            <Input
              id="parent1_email"
              name="parent1_email"
              type="email"
              value={formData.parent1_email}
              onChange={handleChange}
            />
          </div>
          <div>
            <Label htmlFor="parent1_occupation">Occupation</Label>
            <Input
              id="parent1_occupation"
              name="parent1_occupation"
              value={formData.parent1_occupation}
              onChange={handleChange}
            />
          </div>
          <div>
            <Label htmlFor="parent1_education">Highest Education Level</Label>
            <Select value={formData.parent1_education} onValueChange={(value) => handleSelectChange('parent1_education', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Select level" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="High School">High School</SelectItem>
                <SelectItem value="Some College">Some College</SelectItem>
                <SelectItem value="Bachelor's Degree">Bachelor's Degree</SelectItem>
                <SelectItem value="Master's Degree">Master's Degree</SelectItem>
                <SelectItem value="Doctoral Degree">Doctoral Degree</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      <div className="border-t pt-6">
        <h3 className="text-lg font-semibold mb-4">Parent/Guardian 2 (Optional)</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="parent2_first_name">First Name</Label>
            <Input
              id="parent2_first_name"
              name="parent2_first_name"
              value={formData.parent2_first_name}
              onChange={handleChange}
            />
          </div>
          <div>
            <Label htmlFor="parent2_last_name">Last Name</Label>
            <Input
              id="parent2_last_name"
              name="parent2_last_name"
              value={formData.parent2_last_name}
              onChange={handleChange}
            />
          </div>
          <div>
            <Label htmlFor="parent2_email">Email</Label>
            <Input
              id="parent2_email"
              name="parent2_email"
              type="email"
              value={formData.parent2_email}
              onChange={handleChange}
            />
          </div>
          <div>
            <Label htmlFor="parent2_occupation">Occupation</Label>
            <Input
              id="parent2_occupation"
              name="parent2_occupation"
              value={formData.parent2_occupation}
              onChange={handleChange}
            />
          </div>
          <div>
            <Label htmlFor="parent2_education">Highest Education Level</Label>
            <Select value={formData.parent2_education} onValueChange={(value) => handleSelectChange('parent2_education', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Select level" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="High School">High School</SelectItem>
                <SelectItem value="Some College">Some College</SelectItem>
                <SelectItem value="Bachelor's Degree">Bachelor's Degree</SelectItem>
                <SelectItem value="Master's Degree">Master's Degree</SelectItem>
                <SelectItem value="Doctoral Degree">Doctoral Degree</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      <div className="border-t pt-6">
        <h3 className="text-lg font-semibold mb-4">Additional Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="siblings">Number of Siblings</Label>
            <Input
              id="siblings"
              name="siblings"
              type="number"
              min="0"
              value={formData.siblings}
              onChange={handleChange}
            />
          </div>
          <div>
            <Label htmlFor="household_income">Household Income Range</Label>
            <Select value={formData.household_income} onValueChange={(value) => handleSelectChange('household_income', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Select range" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Under $25,000">Under $25,000</SelectItem>
                <SelectItem value="$25,000-$50,000">$25,000-$50,000</SelectItem>
                <SelectItem value="$50,000-$75,000">$50,000-$75,000</SelectItem>
                <SelectItem value="$75,000-$100,000">$75,000-$100,000</SelectItem>
                <SelectItem value="$100,000-$150,000">$100,000-$150,000</SelectItem>
                <SelectItem value="Over $150,000">Over $150,000</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <Button type="submit">Save & Continue</Button>
      </div>
    </form>
  );
};

export default FamilyForm;